import React, { PureComponent } from "react";
import { SETTINGS_TEXT_COLOR, SETTINGS_HEIGHT } from "../../helpers/Const";
import styled from "styled-components/macro";
import { connect } from "react-redux";
import { IconSettingsButton22x22 } from "../common/Buttons";

import closeMessageIcon from "../../../icons/IconDialogClose.png";
import closeMessageIconHover from "../../../icons/IconDialogCloseHover.png";
import closeMessageIconPressed from "../../../icons/IconDialogClosePressed.png";
import messageNotificationIcon from "../../../icons/IndicatorNotification.png";
import messageWarningIcon from "../../../icons/IndicatorAttention.png";
import messageProgressIcon from "../../../icons/IndicatorUpdate.png";
import { Dispatch, iRootState } from "src/rematch/store";
import { Action } from "@rematch/core";

export const NOTIFY = 0;
export const WARN = 1;
export const PROGRESS = 2;

const imgs = [closeMessageIcon, closeMessageIconHover, closeMessageIconPressed, messageNotificationIcon, messageWarningIcon];

const NotificationMessageRoot = styled.div`
  width: 400px;
  display: flex;
  background: white;
  border-radius: 18px 0 0 18px;
  min-height: 36px;
  color: ${SETTINGS_TEXT_COLOR};
  position: absolute;
  right: 0;
  top: ${SETTINGS_HEIGHT}px;
  align-items: flex-start;
  padding: 2px;
  margin-top: 2px;
  z-index: 99;
  justify-content: space-between;
`;

interface INotificationIconProps {
  image: string;
  animation: boolean;
}

const NotificationIcon = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-content: center;
  align-items: center;
  flex: 0 0 32px;
  background-size: contain;
  border: 0;
  background-color: transparent;
  background-image: url(${(props: INotificationIconProps) => props.image});
  ${(props: INotificationIconProps) => props.animation ? "animation: rotate 2s linear infinite;" : ""}
`;

const NotificationSpan = styled.span`
  padding-left: 4px;
  padding-right: 20px;
  padding-top: 5px;
  padding-bottom: 5px;
  user-select: text;
`;

interface INotificationMessageProps {
  notificationMessage: string;
  notificationMessageLevel: number;
  notificationMessageTimeout: number;
  notificationMessageId: number;
  hideMessage: () => Action<void,void>;
}

class NotificationMessage extends PureComponent<INotificationMessageProps> {
  componentDidMount = () => {
    for (const imgURL of imgs) {
      const img = new Image();
      img.src = imgURL;
    }
  };

  render() {
    let notificationIcon;
    let notificationAnimation = false;
    if (this.props.notificationMessageLevel === NOTIFY) {
      notificationIcon = messageNotificationIcon;
    } else if (this.props.notificationMessageLevel === PROGRESS) {
      notificationIcon = messageProgressIcon;
      notificationAnimation = true;
    } else {
      notificationIcon = messageWarningIcon;
    }
    if (this.props.notificationMessage && this.props.notificationMessageTimeout > 0) {
      const currentMessageId = this.props.notificationMessageId;
      //auto hide only NOTIFY-level
      if(this.props.notificationMessageLevel === NOTIFY) {
        setTimeout(() => {
          //hide only if current message is latest message
          if(currentMessageId === this.props.notificationMessageId) {
            this.props.hideMessage();
          }
        }, this.props.notificationMessageTimeout * 1000);
      }
      return (
        <NotificationMessageRoot>
          <NotificationIcon image={notificationIcon} animation={notificationAnimation} />
          <NotificationSpan>{this.props.notificationMessage}</NotificationSpan>
          <IconSettingsButton22x22
            style={{ marginTop: 6 }}
            image={closeMessageIcon}
            imageHover={closeMessageIconHover}
            imagePressed={closeMessageIconPressed}
            onClick={this.props.hideMessage}
          />
        </NotificationMessageRoot>
      );
    }
    return null;
  }
}

const mapState = (state: iRootState) => ({
  notificationMessage: state.UI.notificationMessage,
  notificationMessageLevel: state.UI.notificationMessageLevel,
  notificationMessageTimeout: state.UI.displaySettings.notificationMessageTimeout,
  notificationMessageId: state.UI.notificationMessageId,
});

const mapDispatch = (dispatch: Dispatch) => ({
  hideMessage: dispatch.UI.hideMessage,
});

export default connect(mapState, mapDispatch)(NotificationMessage);
